import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Theme, ListItem, ListItemText, ListItemIcon } from '@mui/material';
import { SatelliteOutlined } from '@mui/icons-material';

import { capitalize, getColourFromStatus } from 'utils';
import { Antenna } from 'models/antennas';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
            maxWidth: 360,
            paddingRight: theme.spacing(2),
        },
        nested: {
            paddingLeft: theme.spacing(4),
        },
    }),
);

interface ListItemProps {
    antenna: Antenna;
    onClick?: () => void;
}

const AntennaListItem: React.FunctionComponent<ListItemProps> = ({
    antenna,
    onClick,
}) => {
    const classes = useStyles();

    return (
        <ListItem
            button
            className={classes.root}
            onClick={() => onClick && onClick()}
        >
            <ListItemIcon>
                <SatelliteOutlined
                    style={{ color: getColourFromStatus(antenna.status) }}
                    fontSize="large"
                />
            </ListItemIcon>
            <ListItemText
                primary={antenna.name}
                secondary={`${capitalize(antenna.status)} - ${
                    antenna.groundstation.name
                }`}
            />
        </ListItem>
    );
};

AntennaListItem.displayName = 'AntennaListItem';
export default AntennaListItem;
